import * as IdbKeyVal from "idb-keyval";

const UsingIosKey = "vwf-usingIos";

export const set = async (usingIos: boolean) => {
    await IdbKeyVal.set(UsingIosKey, usingIos);
}

export const get = async () => {
    let usingIos = false;
    const response = await IdbKeyVal.get<boolean>(UsingIosKey);
    if (response) {
        usingIos = response as boolean;
    }
    return usingIos;
}
